module.exports = __webpack_public_path__ + "img/gluten.e27b0c82.png";